import React, { useEffect, useState } from "react";
import { gql, useLazyQuery } from "@apollo/client";
import { Skeleton, Drawer, Space, Badge } from "antd";
import { PlusCircleOutlined, RotateLeftOutlined } from "@ant-design/icons";
import { Link } from "react-router-dom";
import OtherErrors from "@general/otherErrors";
import moment from "moment-jalaali";
import PackagesTable from "./table";
import PackagesTableDetails from "./tableDetails";
import TableFilters from "@general/tableFilters";
import getWindowSize from "@utils/windowSize";

const GETPACKAGES = gql`
  query ($paginateInput: PaginateInput!, $searchInput: PackageSearchInput!) {
    getPackagesCount(searchInput: $searchInput)
    getPackages(paginateInput: $paginateInput, searchInput: $searchInput) {
      id
      createdAt
      updatedAt
      name
      description
      days
      sessions
      amountRial
      packageType
      product{
        name
        id
      }
    }
  }
`;

function AdminPackages() {
  const [tableData, setTableData] = useState({});
  const [currentPage, setCurrentPage] = useState();
  const [sortDir, setSortDir] = useState("desc");
  const [sortColumn, setSortColumn] = useState("createdAt");
  const [filterDateFrom, setFilterDateFrom] = useState(null);
  const [filterDateTo, setFilterDateTo] = useState(null);
  const [filterSearchPhrase, setFilterSearchPhrase] = useState("");
  const [drawer, setDrawer] = useState(false);

  const windowSize = getWindowSize().innerWidth;

  const [getPackages, packages] = useLazyQuery(GETPACKAGES, {
    fetchPolicy: "no-cache",
    onCompleted(data) {
      setTableData(data);
    },
  });

  useEffect(() => {
    getPackages({
      variables: {
        paginateInput: {
          page: currentPage,
          perPage: 10,
          sort: sortColumn && sortColumn,
          sortDir: sortDir,
        },
        searchInput: {
          createdAt:
            filterDateFrom && filterDateTo
              ? [filterDateFrom, filterDateTo]
              : null,
          textSearch: filterSearchPhrase,
        },
      },
    });
  }, [currentPage, sortDir, filterDateTo, filterSearchPhrase]);

  const dataUpdated = () => {
    getPackages({
      variables: {
        paginateInput: {
          page: currentPage,
          perPage: 10,
          sort: sortColumn && sortColumn,
          sortDir: sortDir,
        },
        searchInput: {},
      },
    });
  };

  const pageChange = (current) => {
    setCurrentPage(current);
  };

  const sort = (sortData) => {
    setCurrentPage(1);
    setSortColumn(sortData.columnKey);
    if (sortData.order === "ascend") setSortDir("asc");
    if (!sortData.order || sortData.order === "descend") setSortDir("desc");
  };

  const filterDate = (dates, dateString) => {
    setCurrentPage(1);
    if (dateString[0] === "" || dateString[1] === "") {
      setFilterDateFrom(null);
      setFilterDateTo(null);
    } else {
      setFilterDateFrom(
        moment(dateString[0], "jYYYY/jMM/jDD")
          .startOf("day")
          .toDate()
          .toISOString()
      );
      setFilterDateTo(
        moment(dateString[1], "jYYYY/jMM/jDD")
          .endOf("day")
          .toDate()
          .toISOString()
      );
    }
  };

  const filterSearch = (phrase) => {
    setCurrentPage(1);
    setFilterSearchPhrase(phrase);
  };

  const openDrawer = (id, name) => {
    setDrawer({ id, name });
  };
  const closeDrawer = () => {
    setDrawer(false);
  };
  if (packages.error) return <OtherErrors />;
  if (Object.keys(tableData).length === 0)
    return (
      <>
        <Skeleton active round />
        <br />
        <Skeleton active round />
      </>
    );
  return (
    <Badge.Ribbon
      style={{
        left: "-32px",
        height: "40px",
        display: "flex",
        alignItems: "center",
        cursor: "pointer"
      }}
      text={
        <Link to="/admin-packages/add-package">
          <span style={{ padding: "10px", color: "white" }}>
            <PlusCircleOutlined /> پکیج جدید
          </span>
        </Link>
      }
    >
      <>
        <Drawer
          title="جزییات پکیج"
          placement="right"
          open={drawer}
          onClose={closeDrawer}
          size={windowSize >= 750 ? "large" : null}
          width={windowSize < 750 ? windowSize - 50 : null}
        >
          <PackagesTableDetails
            id={drawer.id}
            onDataUpdate={dataUpdated}
            onCloseDrawer={closeDrawer}
          />
        </Drawer>

        <TableFilters onFilterDate={filterDate} onFilterSearch={filterSearch} />
        <Space></Space>
        <br />
        <PackagesTable
          onDataUpdate={dataUpdated}
          data={tableData}
          onSort={sort}
          onPageChange={pageChange}
          currentPage={currentPage}
          loading={packages.loading}
          onOpenDrawer={openDrawer}
        />
      </>
    </Badge.Ribbon>
  );
}

export default AdminPackages;
